<template>
  <v-dialog v-model="isVisible" max-width="900">
    <v-card>
      <v-card-title class="input-text-size">{{ header }}</v-card-title>
      <v-card-text class="input-text-size">
 <v-row dense><v-col cols="5" >
                   <ClarionDateControl class="input-text-size"
                         :isRequired="false" :isIsoDate="false" :isToggle="false"
                         label="Penalty Date" v-model="settings.penaltyDate"/>
                </v-col></v-row>
        <v-container>

          <v-row dense>
            <v-col cols="6">
              <h4>Fields to include:</h4>
            </v-col>
            <v-col cols="6">
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="TaxId"
                v-model="settings.taxId"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Parcel ID"
                v-model="settings.parcelId"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <div class="print-order-border mt-n12">
                <h4 class="text-center mb-2">Print Order:</h4>
                <v-radio-group
                  row
                  dense
                  v-model="settings.printOrder"
                  hide-details
                >
                  <v-radio dense
                    class="input-text-size"
                    label="Owner Name"
                    value="orderOwnerName"
                  ></v-radio>
                  <v-radio dense
                    class="input-text-size"
                    label="Tax ID"
                    value="orderTaxId"
                  ></v-radio>
                  <v-radio dense
                    class="input-text-size"
                    label="Parcel ID"
                    value="orderPID"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-col>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Owner name"
                v-model="settings.ownerName"
                :disabled="settings.includeCareOf"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Tax Type"
                v-model="settings.taxType"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Name 2"
                v-model="settings.includeNameTwo"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Full Legal Description"
                v-model="legalDescriptionChecked"
                @change="updateDescriptionType('legalDescription', $event)"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Abbreviated Legal"
                v-model="additionLotBlockChecked"
                @change="updateDescriptionType('additionLotAndBlock', $event)"
              ></v-checkbox>
            </v-col>
            <v-col cols="3">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Care Of"
                v-model="settings.includeCareOf"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Tax, Penalty & Fees Due"
                v-model="settings.taxPenaltyFeesDue"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Total Due"
                v-model="settings.totalDue"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Name & total on same line"
                v-model="settings.singleLineNameAmount"
                :disabled="!settings.ownerName || !settings.totalDue"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-checkbox dense
                hide-details
                class="input-text-size"
                label="Combine records on the same parcel"
                v-model="settings.combineRecords"
              ></v-checkbox>
            </v-col>
          </v-row>
          <div>
            <h4>Preview:</h4>
            <p class="preview-text">{{ previewText }}</p>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn color="primary" small @click="generatePublication">
          Generate
        </v-btn>
        <v-btn small @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { getPrintableCareOfName, penaltyCalculation } from '../common-utils/tax-common.util';
import { taxFeeCheckWitheEfectiveDate, taxPostProcessFeesList } from '../common-utils/CommonTaxFunctionalities';
import { toShortDate } from '../../../util/shared/tmc-global';
import { amountFormat, pIdFormat } from '../../../util/shared/vue-global';

const TAX_TYPE_ABBREVIATIONS = {
  r: 'REAL',
  s: 'SA',
  p: 'PERS',
  m: 'MH',
  b: 'BUS',
  u: 'UTIL',
};

export default {
  name: 'PublicationDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: 'Publication TXT Settings',
    },
    taxInquiryData: {
      type: Array,
      default: () => [],
    },
    browseListData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Completely isolated local state - no Vuex dependency
      settings: {
        taxId: true,
        parcelId: false,
        ownerName: true,
        taxType: false,
        includeNameTwo: false,
        includeCareOf: false,
        descriptionType: 'legalDescription',
        taxPenaltyFeesDue: false,
        includeHeaders: false,
        totalDue: false,
        singleLineNameAmount: false,
        // Off = one section per work-file row, the long-standing layout.
        combineRecords: false,
        amountDisplayType: 'totalDueOnly',
        printOrder: 'orderOwnerName',
        penaltyDate: toShortDate(), // Initialize with today's date
      },
      previewFeeList: [],
    };
  },
  computed: {
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
    }),
    formatPidPositions() {
      return (this.taxSettingItem || {}).pidValue || '';
    },
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    legalDescriptionChecked: {
      get() {
        return this.settings.descriptionType === 'legalDescription';
      },
      set(val) {
        this.updateDescriptionType('legalDescription', val);
      },
    },
    additionLotBlockChecked: {
      get() {
        return this.settings.descriptionType === 'additionLotAndBlock';
      },
      set(val) {
        this.updateDescriptionType('additionLotAndBlock', val);
      },
    },
    totalDueOnlyChecked: {
      get() {
        return this.settings.amountDisplayType === 'totalDueOnly';
      },
      set(val) {
        this.updateAmountDisplayType('totalDueOnly', val);
      },
    },
    sampleData() {
      if (this.taxInquiryData.length > 0) {
        return this.taxInquiryData[0];
      }
      if (this.browseListData.length > 0) {
        return this.browseListData[0];
      }
      return {};
    },
    previewText() {
      // Get sample data for preview
      let sampleData = {};
      if (this.taxInquiryData.length > 0) {
        [sampleData] = this.taxInquiryData;
      } else if (this.browseListData.length > 0) {
        [sampleData] = this.browseListData;
      }

      if (!sampleData || Object.keys(sampleData).length === 0) {
        return 'No data available for preview';
      }

      const previewLines = [];

      // Tax ID and Parcel ID
      // const idFields = [];
      if (this.settings.taxId && sampleData.taxId) {
        let taxIdLine = `Tax Year: ${sampleData.taxYear} Tax ID: ${sampleData.taxId}`;
        const taxTypeAbbreviation = TAX_TYPE_ABBREVIATIONS[(sampleData.taxType || '').toLowerCase()];
        if (this.settings.taxType && taxTypeAbbreviation) {
          taxIdLine += ` ${taxTypeAbbreviation}`;
        }
        previewLines.push(taxIdLine);
      }
      if (this.settings.parcelId && sampleData.propertyOrParcelId) {
        // Preview must match the generated .txt, which formats through the county's pidValue mask.
        previewLines.push(`Parcel ID: ${pIdFormat(sampleData.propertyOrParcelId, this.formatPidPositions)}`);
      }
      // if (idFields.length > 0) {
      //   previewLines.push(idFields.join(' | '));
      // }

      // Owner name (skip if combining with total due on single line)
      // const name1 = sampleData.name1 || '';
      // const name2 = sampleData.name2 || '';
      // const fullName = `${name1}${name2}`;
      // if (this.settings.ownerName && sampleData.name1 && !this.settings.singleLineNameAmount) {
      //   previewLines.push(fullName);
      // }
      const ownerNameDetails = [];
      const printableCareOfName = getPrintableCareOfName(sampleData);
      if (this.settings.includeCareOf && printableCareOfName) {
        ownerNameDetails.push(printableCareOfName);
      } else if (this.settings.ownerName && sampleData.name1) {
        ownerNameDetails.push(sampleData.name1);
      }
      if (this.settings.includeNameTwo && sampleData.name2) {
        ownerNameDetails.push(sampleData.name2);
      }
      const ownerConcatenatedName = ownerNameDetails.join(' ');
      if (ownerConcatenatedName && !this.settings.singleLineNameAmount) previewLines.push(ownerConcatenatedName);

      // Description
      const descriptionFields = [];
      if (this.settings.descriptionType === 'legalDescription' && sampleData.legalDesc) {
        descriptionFields.push(`Legal Description: ${sampleData.legalDesc}`);
      } else if (this.settings.descriptionType === 'additionLotAndBlock') {
        const addition = sampleData.addition || '';
        const lots = sampleData.lots || '';
        const block = sampleData.block || '';
        if (addition || lots || block) {
          descriptionFields.push(`Addition Lot & Block: ${addition} ${lots} ${block}`.trim());
        }
      }
      if (descriptionFields.length > 0) {
        previewLines.push(descriptionFields.join(' | '));
      }

      // Amounts
      let totalDueAmount = 0;
      const { penaltyDate, penaltyRate } = this.taxSettingItem;
      const {
        penaltyStartDate, totalTax, totalPaid, totalDue, taxYear,
      } = sampleData;
      const penDate = this.settings.penaltyDate;
      const fees = taxFeeCheckWitheEfectiveDate(this.previewFeeList, penDate);
      const penaltyResults = penaltyCalculation(
        penDate, penaltyStartDate, penaltyDate, totalTax,
        totalPaid, fees, penaltyRate, totalDue, taxYear,
        [], this.taxSettingItem,
      );
      const penalty = penaltyResults.penaltyAmt;
      totalDueAmount = totalTax + penalty + fees;
      if (this.settings.taxPenaltyFeesDue && (totalTax || penalty || fees)) {
        previewLines.push(`Tax: ${amountFormat(totalTax)} Penalty: ${amountFormat(penalty)} Fees: ${amountFormat(fees)}`.trim());
      }
      if (this.settings.singleLineNameAmount && this.settings.ownerName && this.settings.totalDue) {
        previewLines.push(`${ownerConcatenatedName}    $${amountFormat(totalDueAmount) || 0}`);
      } else if (this.settings.totalDue) {
        previewLines.push(`Total Due: $${amountFormat(totalDueAmount) || 0}`);
      }

      // Amount display type
      if (this.settings.amountDisplayType === 'totalDueOnly' && sampleData.totalDue) {
        // previewLines.push(`Amount: $${sampleData.totalDue} (Total Due Only)`);
      } else if (this.settings.amountDisplayType === 'separateAmounts') {
        const separateAmounts = [];
        if (sampleData.totalTax) {
          separateAmounts.push(`Tax: $${sampleData.totalTax}`);
        }
        if (sampleData.totalFee) {
          separateAmounts.push(`Fees: $${sampleData.totalFee}`);
        }
        if (separateAmounts.length > 0) {
          previewLines.push(`Separate Amounts: ${separateAmounts.join(', ')}`);
        }
      }

      return previewLines.length > 0 ? previewLines.join('\n') : 'Select fields to see preview';
    },
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        // Reset penalty date to today's date when dialog opens
        this.resetPenaltyDate();
        this.loadPreviewFeeList();
      }
    },
    'settings.ownerName': {
      handler(val) {
        if (!val) this.settings.singleLineNameAmount = false;
      },
    },
    'settings.totalDue': {
      handler(val) {
        if (!val) this.settings.singleLineNameAmount = false;
      },
    },
    'settings.includeCareOf': {
      handler(val) {
        if (val) this.settings.ownerName = true;
      },
    },
  },
  components: {
    ClarionDateControl,
  },
  methods: {
    ...mapActions('tax/taxFee', ['taxFeesBasedOnIds']),
    async loadPreviewFeeList() {
      const { _id: taxMongoId } = this.sampleData || {};
      if (!taxMongoId) {
        this.previewFeeList = [];
        return;
      }
      this.previewFeeList = await this.taxFeesBasedOnIds({
        criteria: { ids: [taxMongoId] },
        baseCrudKey: 'publicationDialogFeeList',
        postProcessTrans: taxPostProcessFeesList,
      });
    },
    updateDescriptionType(type, isChecked) {
      if (isChecked) {
        this.settings.descriptionType = type;
      } else {
        this.settings.descriptionType = null;
      }
    },
    updateAmountDisplayType(type, isChecked) {
      if (isChecked) {
        this.settings.amountDisplayType = type;
      } else {
        this.settings.amountDisplayType = null;
      }
    },
    generatePublication() {
      // Emit the settings to parent component
      this.$emit('generate', this.settings);
      this.closeDialog();
    },
    closeDialog() {
      this.isVisible = false;
    },
    resetPenaltyDate() {
      // Reset penalty date to today's date when dialog opens
      this.settings.penaltyDate = toShortDate();
    },
  },
};
</script>

<style scoped>
.print-order-border {
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 8px;
  margin: 4px 0;
}

.preview-text {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  font-family: monospace;
  font-size: 12px;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
